const v3Prefix = "mdv3";
// Wrapper around localstorage for handling auth tokens
export const getCurrentRedirectURI = () => localStorage.getItem(`${v3Prefix}redirectUri`);
export const getHasAuth = () => localStorage.getItem(`${v3Prefix}hasAuth`);
export const getRefreshToken = () => localStorage.getItem(`${v3Prefix}refreshToken`);
export const getRefreshTokenExpiry = () => localStorage.getItem(`${v3Prefix}refreshTokenExpiry`);
export const getToken = () => localStorage.getItem(`${v3Prefix}token`);
export const getTokenExpiry = () => localStorage.getItem(`${v3Prefix}expiry`);
export const getIsSettingInitialPassword = () => localStorage.getItem(`${v3Prefix}isSettingInitialPassword`);
export const getCurrentlyLoggingIn = () => false && localStorage.getItem(`${v3Prefix}currentlyLoggingIn`);
 
export const resetCurrentRedirectURI = () => localStorage.removeItem(`${v3Prefix}redirectUri`);
export const resetHasAuth = () => localStorage.removeItem(`${v3Prefix}hasAuth`);
export const resetRefreshToken = () => localStorage.removeItem(`${v3Prefix}refreshToken`);
export const resetRefreshTokenExpiry = () => localStorage.removeItem(`${v3Prefix}refreshTokenExpiry`);
export const resetToken = () => localStorage.removeItem(`${v3Prefix}token`);
export const resetTokenExpiry = () => localStorage.removeItem(`${v3Prefix}expiry`);
export const resetIsSettingInitialPassword = () => localStorage.removeItem(`${v3Prefix}isSettingInitialPassword`);
export const resetCurrentlyLoggingIn = () => localStorage.removeItem(`${v3Prefix}currentlyLoggingIn`);

export const setCurrentRedirectURI = redirectUri => localStorage.setItem(`${v3Prefix}redirectUri`, `${redirectUri}`);
export const setHasAuth = hasAuth => localStorage.setItem(`${v3Prefix}hasAuth`, `${hasAuth}`);
export const setRefreshToken = refreshToken => localStorage.setItem(`${v3Prefix}refreshToken`, `${refreshToken}`);
export const setRefreshTokenExpiry = refreshTokenExpiry => localStorage.setItem(`${v3Prefix}refreshTokenExpiry`, `${refreshTokenExpiry}`);
export const setToken = token => localStorage.setItem(`${v3Prefix}token`, `${token}`);
export const setTokenExpiry = expiry => localStorage.setItem(`${v3Prefix}expiry`, `${expiry}`);
export const setIsSettingInitialPassword = val => localStorage.setItem(`${v3Prefix}isSettingInitialPassword`, val);
export const setCurrentlyLoggingIn = () => localStorage.setItem(`${v3Prefix}currentlyLoggingIn`, "true");

export const setFullToken = token => localStorage.setItem(`${v3Prefix}fullToken`, token);
export const getFullToken = () => localStorage.getItem(`${v3Prefix}fullToken`);
export const resetFullToken = () => localStorage.removeItem(`${v3Prefix}fullToken`);


export const getAllAuthValuesInLocalStorage = () => ({
    expiry: getTokenExpiry(),
    hasAuth: getHasAuth(),
    refreshToken: getRefreshToken(),
    refreshTokenExpiry: getRefreshTokenExpiry(),
    token: getToken(),
    fullToken: getFullToken()
});

export const setAllAuthValuesInLocalStorage = ({
    hasAuth,
    refreshTokenExpiry,
    refreshToken,
    token,
    expiry,
    fullToken
}) => {
    hasAuth && setHasAuth(hasAuth);
    refreshToken && setRefreshToken(refreshToken);
    refreshTokenExpiry && setRefreshTokenExpiry(refreshTokenExpiry);
    token && setToken(token);
    expiry && setTokenExpiry(expiry);
    fullToken && setFullToken(fullToken);
};

export const resetAllAuthValuesInLocalStorage = () => {
    resetHasAuth();
    resetRefreshToken();
    resetRefreshTokenExpiry();
    resetToken();
    resetTokenExpiry();
    resetFullToken();
};

export const cleanupLocalstorageLoginItems = () => {
    resetCurrentRedirectURI();
    resetIsSettingInitialPassword();
    resetCurrentlyLoggingIn();
};
